export default __webpack_public_path__ + "static/media/151-barrow.28685b11.png";